<template>
    <div v-if="isLoading" class="spinner__cover">
        <div class="loading-container spinner__cover">
            <img  src="../../../../public/img/loading_latino.gif" alt="Loading..." class="loading-gif" >
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props:{
        isLoading: Boolean
    },
    data() { 
      return {
      };
    }
  };
  </script>
  <style lang="scss" scoped>
  .loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); /* Puedes ajustar la opacidad y el color de fondo según tus preferencias */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-gif {
  width: 120px; /* Ajusta el tamaño del GIF según tus necesidades */
  height: 120px; /* Ajusta el tamaño del GIF según tus necesidades */
}
  .spinner__cover {
  background-color: rgba(0, 58, 113, 0.295) !important;
  backdrop-filter: blur(3px);
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh !important;
}
.spinner__container {
  position: relative;
  img {
    position: absolute;
    top: -10px;
    left: -7px;
  }
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid #003b71;
  border-right: 0.5em solid #003b71;
  border-bottom: 0.5em solid #003b71;
  border-left: 0.5em solid white;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
  </style>